<template>
  <div>
    <section>
      <div class="inspiration">
        <h1>Get inspiration from these storefronts</h1>
        <h2>
          We have a lot of creators with really cool storefront designs you can
          take inspiration from!
        </h2>
        <div
          v-motion
          class="storefront"
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        >
          <img src="/img/raux-scrolling.gif" alt="" class="forWeb" />
          <img src="/img/aryn-scrolling.gif" alt="" class="forWeb" />
          <img src="/img/spart-scrolling.gif" alt="" class="forWeb" />
          <img src="/img/alma.gif" alt="" class="forWeb" />

          <div id="mobileOnly" class="scrolling snaps-inline">
            <div class="scroll-element">
              <img src="/img/raux-scrolling.gif" alt="" />
            </div>
            <div class="scroll-element">
              <img src="/img/aryn-scrolling.gif" alt="" />
            </div>
            <div class="scroll-element">
              <img src="/img/spart-scrolling.gif" alt="" />
            </div>
            <div class="scroll-element">
              <img src="/img/alma.gif" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
#mobileOnly {
  display: none;
}

.forWeb {
  pointer-events: none;
}

section {
  width: 100%;
  padding: 2rem;
  text-align: center;
}

.inspiration {
  max-width: 90rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0;
}

.inspiration h1 {
  margin-bottom: 1rem;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
}

.inspiration h2 {
  max-width: 40rem;
  margin: auto;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  opacity: 0.5;
  margin-bottom: 2rem;
}

.storefront {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.storefront img {
  width: 100%;
  margin-top: 2rem;
}

@media only screen and (max-width: 800px) {
  .inspiration h1 {
    text-align: center;
    font-size: 1.5rem;
  }

  .storefront {
    grid-template-columns: 1fr;
  }

  .forWeb {
    display: none;
  }

  #mobileOnly {
    width: 100%;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 63%;
    gap: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;

    overflow-x: auto;
    overscroll-behavior-inline: contain;
  }

  #mobileOnly::-webkit-scrollbar {
    display: none;
  }

  #igMobile {
    display: block;
  }

  .scroll-element {
    padding: 0.5rem;
  }

  .snaps-inline {
    scroll-snap-type: inline mandatory;
  }

  .snaps-inline > * {
    scroll-snap-align: start;
  }
}
</style>
